import React from "react";

interface IconProps {
  className?: string;
}

export const EditIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="edit-icon"
    style={{ width: "16px", height: "16px" }}
  >
    <g clipPath="url(#clip0_2019_1701)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8978 1.25278C13.1168 0.471731 11.8504 0.471729 11.0694 1.25278L1.63098 10.6912C1.35178 10.9704 1.16146 11.326 1.08403 11.7131L0.692649 13.6701C0.506057 14.603 1.32862 15.4256 2.26158 15.239L4.21847 14.8476C4.60565 14.7702 4.96125 14.5799 5.24045 14.3007L14.6788 4.86225C15.4599 4.08121 15.4599 2.81488 14.6788 2.03383L13.8978 1.25278ZM12.0121 2.19559C12.2725 1.93524 12.6946 1.93524 12.955 2.19559L13.736 2.97664C13.9964 3.23699 13.9964 3.65909 13.736 3.91945L11.9549 5.7005L10.2312 3.97664L12.0121 2.19559ZM9.28828 4.91946L2.57378 11.634C2.48072 11.7271 2.41728 11.8456 2.39147 11.9747L2.00009 13.9315L3.95698 13.5401C4.08604 13.5143 4.20458 13.4509 4.29764 13.3579L11.0122 6.64331L9.28828 4.91946Z"
        fill="#323232"
      />
    </g>
    <defs>
      <clipPath id="clip0_2019_1701">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CloseIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="close-icon"
    style={{ width: "16px", height: "16px" }}
  >
    <path
      d="M12.5 3.5L3.5 12.5"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 3.5L12.5 12.5"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronIcon: React.FC<IconProps> = ({ className = "" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`chevron-icon ${className}`}
    style={{ width: "16px", height: "16px" }}
  >
    <path
      d="M12.4004 5.00002L8.20041 10.25L4.00042 5.00002"
      stroke="#323232"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
); 